import { default as svg } from '../../../../assets/logo.svg';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';
import SignedInHeaderSection from '../../../layout/SignedInHeaderSection';

export default function Header() {
  return (
    <header className={styles.header}>
      <Link to="/">
        <img src={svg} />
      </Link>
      <div className={styles['right-block']}>
        <SignedInHeaderSection showProfile={false} />
      </div>
    </header>
  );
}
